import type {
    RibbonTabDefinitionBase,
    RibbonTabDefinitionSet,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { getIsViewModeSelected } from 'owa-command-ribbon-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import getFullComposeShowingInTabContentArea from 'owa-mail-compose-actions/lib/selectors/getFullComposeShowingInTabContentArea';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import getSLRFormatTab from './SLR/slr-format-tab/getSLRFormatTab';
import getSLRHomeTab from './SLR/slr-home-tab/getSLRHomeTab';
import getSLRMessageTab from './SLR/slr-message-tab/getSLRMessageTab';
import getSLRViewTab from './SLR/slr-view-tab/getSLRViewTab';
import getToolbarHomeTab from './Toolbar/tlbar-home-tab/getToolbarHomeTab';
import getToolbarMessageTab from './Toolbar/tlbar-message-tab/getToolbarMessageTab';
import getSLRInsertTab from './SLR/slr-insert-tab/getSLRInsertTab';

export const getMailRibbonDefinitionsSLR = computedFn(
    (props: RibbonControlDefinitionProps): RibbonTabDefinitionSet => {
        const tabs: RibbonTabDefinitionBase[] = [];

        if (getIsViewModeSelected(CommandingViewMode.SingleLineRibbon)) {
            tabs.push(getSLRHomeTab(props));
            tabs.push(getSLRViewTab(props));

            if (getFullComposeShowingInTabContentArea()) {
                tabs.push(getSLRMessageTab(props));

                if (isFeatureEnabled('cmp-ribbonInsertTab')) {
                    tabs.push(getSLRInsertTab(props));
                }

                if (isFeatureEnabled('cmp-ribbonFormatTextTab')) {
                    tabs.push(getSLRFormatTab(props));
                }
            }
        } else {
            tabs.push(getToolbarHomeTab(props));

            if (getFullComposeShowingInTabContentArea()) {
                tabs.push(getToolbarMessageTab(props));
            }
        }

        return {
            tabs: tabs,
        };
    }
);
